import React, { Component } from 'react'
import _ from 'lodash'
import liffHelper from '../utils/liffHelper'
import utils from '../utils/utils'
import CeApi from '../lib/ce_api'
import Header from './components/Header';

const liff = liffHelper.getLiff()

export default class LIFFWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      liff_id: "",
      init_success: false,
      profile: {},
      login_channel_id: "",
      email_input: "",
      phone_input: "",
      disabled_email_input: true,
      ce_user: {},
      button_fetching: false
    }
  }

  openLIFFWindow() {
    liffHelper.openWindow(this.textInput.value, false);
  }

  openLIFFWindowExternal() {
    liffHelper.openWindow(this.textInput.value, true);
  }

  async loginIfNot () {
    if (!await liff.isLoggedIn()) {
      // set `redirectUri` to redirect the user to a URL other than the front page of your LIFF app.
      await liff.login()
    }
  }

  async componentDidMount() {
    try {
      // liff id要從route抓
      let liffId = this.props.match.params.liff_id

      await liff.init({ liffId: liffId })

      if (!await liff.isLoggedIn()) {
        // set `redirectUri` to redirect the user to a URL other than the front page of your LIFF app.
        return await liff.login()
      }

      let decodeToken = await liff.getDecodedIDToken()
      if(!decodeToken.aud) throw new Error("loss login_channel_id")
      let login_channel_id = decodeToken.aud

      let profile = await liff.getProfile()
      if(!profile || !profile.userId) {
        window.alert("Oops! 從line官方獲取資料時失敗")
        return liff.closeWindow()
      }

      // let profile = {"userId":"U2b72b25be8a9fbe158ff6740b1650ab7","displayName":"阿康康","pictureUrl":"https://profile.line-scdn.net/0m0064285a72510a95740baf681b281f8f6adc33ebe203"}
      // let login_channel_id = "1653882163"

      let stateToBeSet = { init_success: true, login_channel_id, profile }

      let ceUserResult = await CeApi.getUserByLineId(profile.userId, login_channel_id)
      console.log(ceUserResult)
      if(!ceUserResult) {
        window.alert("Oops! 獲取後台line個人資料失敗")
        return liff.closeWindow()
      }

      if(!_.isEmpty(ceUserResult.result))  {
        const ce_user = ceUserResult.result
        stateToBeSet.ce_user = ce_user
        stateToBeSet.email_input = ce_user.email
        stateToBeSet.phone_input = ce_user.phone
      }
      await this.setState(stateToBeSet)
    } catch (e) {
      console.log(e)
      window.alert("Oops! line資料初始化失敗")
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.init_success !== this.state.init_success && this.state.init_success === true) {
    }
    if (prevState.email_input !== this.state.email_input || prevState.phone_input !== this.state.phone_input ) {
      this.validateFields()
    }
  }

  clickSubmitCreate = async (event) => {
    let email = this.state.email_input
    let phone = this.state.phone_input
    let line_user_id = this.state.profile.userId
    let channel_id = this.state.login_channel_id
    let display_name = this.state.profile.displayName

    try {
      await this.setState({ "button_fetching": true })
      let result = await CeApi.postLineUserEmail(line_user_id, channel_id, email, phone, display_name)
      await this.setState({ "button_fetching": false })
      window.alert("email設定成功!, 即將關閉設定頁面", result)
      return liff.closeWindow()
    } catch (e) {
      console.log("錯誤在這", e.message)
      await this.setState({ "button_fetching": false })
      window.alert("Oops! 似乎發生了什麼錯誤, 請稍後嘗試")
    }
  }

  clickSubmitEdit = async (event) => {
    let email = this.state.email_input
    let phone = this.state.phone_input
    let line_user_id = this.state.profile.userId
    let loginChannelId = this.state.login_channel_id
    let display_name = this.state.profile.displayName

    try {
      await this.setState({ "button_fetching": true })
      let result = await CeApi.putLineUserEmail(line_user_id, loginChannelId, email, phone, display_name)
      await this.setState({ "button_fetching": false })
      window.alert("email設定成功!, 即將關閉設定頁面")
      return liff.closeWindow()
    } catch (e) {
      await this.setState({ "button_fetching": false })
      window.alert("Oops! 似乎發生了什麼錯誤, 請稍後嘗試")
    }
  }

  handleParamsChange = async event => {
    let state = {}

    state[event.target.name] = event.target.value
    await this.setState(state)
  }
  handleEmailChange = async  event => {
    let email = event.target.value

    email = email.trim()

    await this.setState({ "email_input": email })
  }
  handlePhoneChange = async event => {
    let phone = event.target.value

    phone = phone.trim()

    await this.setState({ "phone_input": phone })
  }
  async validateFields () {
    let state = {}
    let email = this.state.email_input
    let phone = this.state.phone_input

    let emailValid = utils.validateEmail(email)
    let phoneValid = (phone != "") && phone.length && phone.length > 0

    if(emailValid && phoneValid) {
      state.disabled_email_input = false
      this.setState(state)
    } else {
      state.disabled_email_input = true
      this.setState(state)
    }
  }

  render() {
    const ce_user = this.state.ce_user
    const button_fetching = this.state.button_fetching
    let form
    if(_.isEmpty(ce_user)) {
      form = <div className="col-lg-8">
        <div className="form-group">
          <label htmlFor="email_input">設定EMAIL:</label>
          <input name="email_input" type="text" className="form-control"
          id="email_input" placeholder="請輸入您的email" onChange={this.handleEmailChange} value={this.state.email_input}/>
        </div>
        <div className="form-group">
          <label htmlFor="phone_input">設定電話:</label>
          <input name="phone_input" type="text" className="form-control"
          id="phone_input" placeholder="請輸入您的電話" onChange={this.handlePhoneChange} value={this.state.phone_input}/>
        </div>
        <hr />
        <button type="button" className="btn btn-secondary" onClick={this.clickSubmitCreate} disabled={this.state.disabled_email_input}>
          {
            button_fetching ?
            <div>
              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              送出資料...
            </div>
            :
            <div>確認送出</div>
          }
        </button>
      </div>
    } else {
      form = <div className="col-lg-8">
        <div className="alert alert-success" role="alert">
          您已加入會員, 在此可以修改您的資料
        </div>
        <div className="form-group">
          <label htmlFor="email_input">修改EMAIL:</label>
          <input name="email_input" type="text" className="form-control"
          id="email_input" placeholder="請輸入您的email" onChange={this.handleEmailChange} value={this.state.email_input}/>
        </div>
        <div className="form-group">
          <label htmlFor="phone_input">修改電話:</label>
          <input name="phone_input" type="text" className="form-control"
          id="phone_input" placeholder="請輸入您的電話" onChange={this.handlePhoneChange} value={this.state.phone_input}/>
        </div>
        <hr />
        <button type="button" className="btn btn-secondary" onClick={this.clickSubmitEdit} disabled={this.state.disabled_email_input || button_fetching}>
          {
            button_fetching ?
            <div>
              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              送出資料...
            </div>
            :
            <div>確認修改</div>
          }
        </button>

      </div>
    }


    return (
      <React.Fragment>
        <header className="app-header">
          <h3 className="app-title">會員資料設定</h3>
        </header>
        <div className="page-content">
          <div className="container">
            <div className="row">

            <div className="col" />
            { form }
            <div className="col" />

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/EnterEmail.js